// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ShareIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ShareIcon" ref={forwardedRef} {...props}>
      <path d="M17 4.998a3 3 0 0 1-5.15 2.093L7.954 9.47a3 3 0 0 1-.058 1.319l3.784 2.31a3 3 0 1 1-.633 1.371L7.15 12.092a3 3 0 1 1 .17-3.993l3.785-2.31A3.002 3.002 0 0 1 14 1.999a3 3 0 0 1 3 2.999M15.5 15a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-9-5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m9-5.002a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ShareIcon = /* @__PURE__ */ Object.assign(ShareIconComponent, {
  displayName: 'ShareIcon',
});
